// extracted by mini-css-extract-plugin
export var cellNote = "MultiComparisonTable-module--cellNote--b42f0";
export var check = "MultiComparisonTable-module--check--35f64";
export var competitorCell = "MultiComparisonTable-module--competitorCell--f4a9e";
export var competitorHeader = "MultiComparisonTable-module--competitorHeader--e463c";
export var feature = "MultiComparisonTable-module--feature--d4983";
export var featureHeader = "MultiComparisonTable-module--featureHeader--5722e";
export var note = "MultiComparisonTable-module--note--abb06";
export var presetCell = "MultiComparisonTable-module--presetCell--932c4";
export var presetHeader = "MultiComparisonTable-module--presetHeader--0bb8d";
export var row = "MultiComparisonTable-module--row--3ecbe";
export var table = "MultiComparisonTable-module--table--81004";
export var tableWrapper = "MultiComparisonTable-module--tableWrapper--1fe5c";
export var x = "MultiComparisonTable-module--x--75d33";